import { computed } from "vue";

import { $t } from "@/i18n";
import { Routes } from "@/router";
import type { NavNode } from "@/utils/navUtils";

export function useAccountingNav() {
  return computed<NavNode>(() => ({
    label: $t("common.label.accounting"),
    icon: "phosphor/calculator",
    layoutStoreKey: "accounting",
    children: [
      {
        label: $t("common.label.journal"),
        route: { name: Routes.ACCOUNTING_JOURNAL },
      },
    ],
  }));
}
